module.exports = __webpack_public_path__ + "static/media/Aitcheson College c. 1900s.c777c92c.jpg";